import { useEffect } from 'react';

const ScriptLoader = ({ src, onLoad }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', onLoad);
        document.body.appendChild(script);

        // return () => {
        //     document.body.removeChild(script);
        // };
    }, []);

    return null;
};

export default ScriptLoader;
